import React from 'react';
import { useDrop } from 'react-dnd';
import { ItemTypes } from '../../constants/ItemTypes';
import styles from './Slot.module.scss';

const Slot = ({ children, moveCard, canMoveCard }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ItemTypes.CARD,
    drop: moveCard,
    canDrop: canMoveCard,
    collect: monitor => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
      item: monitor.item
    })
  });

  const classNames = [styles.Slot];
  if (isOver && canDrop) {
    classNames.push(styles.Dropable);
  } else if (isOver && !canDrop) {
    classNames.push(styles.NotDropable);
  }
  return (
    <div ref={drop} className={classNames.join(' ')}>
      {children}
    </div>
  );
};

export default Slot;
